<template>
  <div class="generic-picker">
    <div class="error" v-if="error && error !== '' && !selected">
      <el-tooltip v-if="compactError" class="item" effect="dark" :content="firstError" placement="top-start">
        <i class="el-icon-warning" />
      </el-tooltip>
      {{ !compactError ? firstError : '' }}
    </div>
    <div v-if="selected && !hidePlaceholder" :class="{ hasIcon: icon }" class="visible-placeholder">
      {{ placeholder }}
    </div>
    <fa v-if="icon" slot="prefix" :icon="icon" class="el-input__icon icon" />
    <el-select v-model="model" :value-key="valueKey || 'id'"
      :placeholder="placeholder"
      :disabled="disabled"
      @change="onChange"
      :size="size"
      :clearable="clearable"
      :popper-append-to-body="true"
      class="generic-select"
      :class="{ selected: selected && !hidePlaceholder }"
      :multiple="multiple ? true : false"
      :collapse-tags="collapseTags || false">
      <el-option-group
      :key="placeholder"
      :label="placeholder">
        <el-option
          v-for="item in collection"
          v-if="!activeOnly || item.active"
          :key="item[valueKey || 'id']"
          :label="item.name"
          :value="item">
        </el-option>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'GenericPicker',
  props: {
    compactError: Boolean,
    error: [String, Object, Array],
    collapseTags: Boolean,
    activeOnly: {
      type: Boolean,
      required: false
    },
    limit: {
      type: Array,
      required: false
    },
    multiple: {
      type: Boolean,
      required: false
    },
    api: {
      type: String,
      required: false
    },
    apiData: {
      type: Array,
      required: false
    },
    hidePlaceholder: {
      type: Boolean,
      required: false
    },
    placeholder: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false
    },
    value: {
      required: false
    },
    icon: {
      required: false
    },
    disabled: {
      required: false
    },
    valueKey: {
      required: false
    },
    clearable: {
      type: Boolean,
      required: false
    },
    exclude: {
      type: Array
    }
  },
  data () {
    return {
      selected: false,
      model: null,
      collection: this.apiData || []
    }
  },
  computed: {
    firstError () {
      if (typeof this.error === 'object') {
        return this.error[0]
      }

      return this.error
    }
  },
  methods: {
    onChange (selected, index) {
      if (!this.multiple) {
        this.$emit('input', selected[this.valueKey || 'id'])
      } else {
        if (!this.valueKey) {
          this.$emit('input', selected)
        } else {
          this.$emit('input', selected.map(a => a[this.valueKey]))
        }
      }
      this.$emit('pick', selected)
    },
    setModel () {
      if (this.multiple) {
        if (!this.valueKey) {
          this.model = this.value
        } else {
          this.model = []
          if (Array.isArray(this.value)) {
            this.value.map(x => {
              this.model.push({[this.valueKey]: x})
            })
          }
        }
      } else {
        this.model = { [this.valueKey || 'id']: this.value } || ''
      }
    },
    async fetchCollection () {
      const response = await this.$http.get(this.api)
      if (this.limit && this.limit.length > 0) {
        this.collection = response.data.filter(item => {
          if (this.limit.includes(item.id)) {
            return item
          }
        })
      } else {
        this.collection = response.data
      }

      if (this.exclude) {
        this.collection = this.collection.filter(item => {
          if (!this.exclude.find(id => item.id === id)) {
            return item
          }
        })
      }
      this.$emit('loaded', response.data, this.model)
    }
  },
  created () {
    this.setModel()
    if (!this.apiData) {
      this.fetchCollection()
    }
  },
  watch: {
    model () {
      if (this.model !== '' && this.model !== null && this.model.id !== null && this.model.id !== '') {
        this.selected = true
      }
    },
    value () {
      this.setModel()
    }
  }
}
</script>

<style lang="scss">

  .error {
    color: $red;
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    z-index: 3000;

    > i {
      font-size: 14px;
    }
  }

.visible-placeholder {
  position: absolute;
  color: $text;
  transform-origin: 0px;
  transform: scale(0.8);
  left: 0px;
  top: 3px;
  font-size: 13px;
  z-index: 2000 !important;

  &.hasIcon {
    padding-left: 38px;
  }
}

.el-select__tags {
  padding-left: 0px;
}

.generic-picker {
  position: relative;
  .icon {
    position: absolute;
    z-index: 2;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
    height: 14px;
    color: #c0c4cc;

    &+.generic-select input {
      padding-left: 30px;
    }
  }

  .generic-select {
    width: 100%;
  }

  .selected {
    .el-input--suffix .el-input__inner {
      padding-top: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/CollectionPicker.vue